var E = 401, a = ["/auth/mfa/validate-credentials"], A = "No token available", T = "rx-user-id";
export {
  T as AUTHENTICATED_USER_STORAGE_KEY,
  a as CREDENTIAL_VALIDATION_ENDPOINTS,
  A as NO_TOKEN_AVAILABLE_MESSAGE,
  E as UNAUTHORIZED_STATUS
};

//# sourceMappingURL=expectedError.constants.js.map